// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2uKyc","counter":"Item_counter__25pFL","icon":"Item_icon__w9Q6B","title":"Item_title__20dC3","content":"Item_content__1t3mb"};